export const FETCH_INSPECTIONS_REQUEST = "FETCH_INSPECTIONS_REQUEST";
export const FETCH_INSPECTIONS_SUCCESS = "FETCH_INSPECTIONS_SUCCESS";
export const FETCH_INSPECTIONS_ERROR = "FETCH_SITE_ERROR";

export const CREATE_INSPECTION_REQUEST = "CREATE_INSPECTION_REQUEST";
export const CREATE_INSPECTION_SUCCESS = "CREATE_INSPECTION_SUCCESS";
export const CREATE_INSPECTION_ERROR = "CREATE_INSPECTION_ERROR";

export const FETCH_INSPECTION_REQUEST = "FETCH_INSPECTION_REQUEST";
export const FETCH_INSPECTION_SUCCESS = "FETCH_INSPECTION_SUCCESS";
export const FETCH_INSPECTION_ERROR = "FETCH_INSPECTION_ERROR";

export const FETCH_GENERATE_NOTIFICATION_REQUEST = "FETCH_GENERATE_NOTIFICATION_REQUEST";
export const FETCH_GENERATE_NOTIFICATION_SUCCESS = "FETCH_GENERATE_NOTIFICATION_SUCCESSv";
export const FETCH_GENERATE_NOTIFICATION_ERROR = "FETCH_GENERATE_NOTIFICATION_ERROR";

export const DEFECT_IMAGE_DELETE_REQUEST = 'DEFECT_IMAGE_DELETE_REQUEST';
export const DEFECT_IMAGE_DELETE_SUCCESS = 'DEFECT_IMAGE_DELETE_SUCCESS';

export const DEFECT_CLOSE_REQUEST = 'DEFECT_CLOSE_REQUEST';
export const DEFECT_CLOSE_SUCCESS = 'DEFECT_CLOSE_SUCCESS';

export const INSPECTION_FILE_DELETE_REQUEST = 'INSPECTION_FILE_DELETE_REQUEST';
export const INSPECTION_FILE_DELETE_SUCCESS = 'INSPECTION_FILE_DELETE_SUCCESS'

export const CLOSE_INSPECTION_REQUEST = 'CLOSE_INSPECTION_REQUEST';
export const CLOSE_INSPECTION_SUCCESS = 'CLOSE_INSPECTION_SUCCESS';
export const CLOSE_INSPECTION_ERROR = 'CLOSE_INSPECTION_ERROR';

export const COPYWRONG_VISIT_REQUEST = "COPYWRONG_VISIT_REQUEST";
export const COPYWRONG_VISIT_SUCCESS = "COPYWRONG_VISIT_SUCCESS";
export const COPYWRONG_VISIT_ERROR = "COPYWRONG_VISIT_ERROR";

export const CLONE_VISIT_REQUEST = "CLONE_VISIT_REQUEST";
export const CLONE_VISIT_SUCCESS = "CLONE_VISIT_SUCCESS";
export const CLONE_VISIT_ERROR = "CLONE_VISIT_ERROR";

export const fetchInspections = (id) => {
    return {
        type: 'CALL_API',
        types: [FETCH_INSPECTIONS_REQUEST, FETCH_INSPECTIONS_SUCCESS, FETCH_INSPECTIONS_ERROR],
        path: `api/siteinspection?addressId=${id}&order=-start_date`,
        payload: id
    };
};

export const createInspection = (addressId, governmentLand, createNewVisit = false) => {
    return {
        type: 'CALL_API',
        types: [CREATE_INSPECTION_REQUEST, CREATE_INSPECTION_SUCCESS, CREATE_INSPECTION_ERROR],
        path: `api/siteinspection`,
        method: 'post',
        payload: {address_id: addressId, is_government_land: governmentLand},
        redirect: ((response) => {
             return createNewVisit ?
                 `/inspection/${response.inspection.id}/visit` :
                 `/inspection/${response.inspection.id}`;
        })
    };
};

export const fetchInspection = (id) => {
    return {
        type: 'CALL_API',
        types: [FETCH_INSPECTION_REQUEST, FETCH_INSPECTION_SUCCESS, FETCH_INSPECTION_ERROR],
        path: `api/siteinspection/${id}`,
        method: 'get',
        payload: {id: id},
    };
};

export const fetchInspectionQuiet = (id) => {
    return {
        type: 'CALL_API',
        types: [FETCH_INSPECTION_REQUEST, FETCH_INSPECTION_SUCCESS, FETCH_INSPECTION_ERROR],
        path: `api/siteinspection/${id}`,
        method: 'get',
        payload: {id: id},
        quiet: true
    };
};

export const fetchGenerateNotification = (id) => {
    return {
        type: 'CALL_API',
        types: [FETCH_GENERATE_NOTIFICATION_REQUEST, FETCH_GENERATE_NOTIFICATION_SUCCESS, FETCH_GENERATE_NOTIFICATION_ERROR],
        path: `api/notification/${id}`,
        method: 'get',
        payload: {id: id},
    };
};

export const deleteDefectImage = (siteInspectionId, defectId, beforeAfter) => {
    return {
        type: 'CALL_API',
        types: [DEFECT_IMAGE_DELETE_REQUEST, DEFECT_IMAGE_DELETE_SUCCESS],
        path: `api/siteinspection/${siteInspectionId}/defects/${defectId}/image/${beforeAfter}`,
        method: 'DELETE' ,
        payload: defectId
    };
};

export const deleteInspectionFile = (siteInspectionId, inspectionFileId) => {
    return {
        type: 'CALL_API',
        types: [INSPECTION_FILE_DELETE_REQUEST, INSPECTION_FILE_DELETE_SUCCESS],
        path: `api/siteinspection/${siteInspectionId}/inspectionFiles/${inspectionFileId}`,
        method: 'DELETE' ,
        payload: {
            inspectionFileId :inspectionFileId, 
        } 
    };
};

export const resolveDefect = (siteInspectionId, defectId, resolvedBy, comment) => {
    return {
        type: 'CALL_API',
        types: [DEFECT_CLOSE_REQUEST, DEFECT_CLOSE_SUCCESS],
        path: `api/siteinspection/${siteInspectionId}/defects/${defectId}/close`,
        method: 'PUT',
        payload: {resolved_by: resolvedBy, comment: comment}
    };
};

export const closeInspectionNoIncident = (siteInspectionId) => {
    return {
        type: 'CALL_API',
        types: [CLOSE_INSPECTION_REQUEST, CLOSE_INSPECTION_SUCCESS, CLOSE_INSPECTION_ERROR],
        path: `api/siteinspection/${siteInspectionId}/visit/no-incident`,
        method: 'POST',
    };
};

export const closeInspectionCustomerCleared = (siteInspectionId) => {
    return {
        type: 'CALL_API',
        types: [CLOSE_INSPECTION_REQUEST, CLOSE_INSPECTION_SUCCESS, CLOSE_INSPECTION_ERROR],
        path: `api/siteinspection/${siteInspectionId}/close/customer`,
        method: 'POST',
    };
};

export const closeInspectionContractorCleared = (siteInspectionId) => {
    return {
        type: 'CALL_API',
        types: [CLOSE_INSPECTION_REQUEST, CLOSE_INSPECTION_SUCCESS, CLOSE_INSPECTION_ERROR],
        path: `api/siteinspection/${siteInspectionId}/close/contractor`,
        method: 'POST',
    };
};

export const closeInspectionCreatedInError = (siteInspectionId) => {
    return {
        type: 'CALL_API',
        types: [CLOSE_INSPECTION_REQUEST, CLOSE_INSPECTION_SUCCESS, CLOSE_INSPECTION_ERROR],
        path: `api/siteinspection/${siteInspectionId}/close/error`,
        method: 'POST',
    };
};

export const copyWronglyRecordedVisit = (inspectionId, addressId, government_land) => {
    return {
        type: 'CALL_API',
        types: [COPYWRONG_VISIT_REQUEST, COPYWRONG_VISIT_SUCCESS, COPYWRONG_VISIT_ERROR],
        path: `api/visit/inspection/${inspectionId}/move`,
        method: 'post',
        payload: {
            target_address_id: addressId,
            government_land: government_land
        },
    };
};


export const cloneLastVisit = (inspectionId) => {
    return {
        type: 'CALL_API',
        types: [CLONE_VISIT_REQUEST, CLONE_VISIT_SUCCESS, CLONE_VISIT_ERROR],
        path: `api/visit/inspection/${inspectionId}/clonelast`,
        method: 'post'
    };
};

export const customerEngagedContractorAction = (siteInspectionId, date) => {
  return {
      type: 'CALL_API',
      types: [CLOSE_INSPECTION_REQUEST, CLOSE_INSPECTION_SUCCESS, CLOSE_INSPECTION_ERROR],
      path: `api/siteinspection/${siteInspectionId}/customerengagedcontractor`,
      method: 'put',
      payload: {
        date_customer_booked_contractor: date
      }
  };
};




// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/inspection.js